import React from 'react'
import { IssueSelect } from '../../../components'
import { SystemProvider } from '../../../features/system/provider'
import { updateForm as updateBlogForm } from '../../../features/blog-form/slice'
import { useDispatch, useSelector } from 'react-redux'
import debounce from 'lodash.debounce'

const SidebarIssue = () => {
  const dispatch = useDispatch()
  const form = useSelector(state => state.blogForm.data)
  const { issue } = form
  const updateForm = debounce((e) => {
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updateBlogForm({key, value}))
    }
  }, 250)

  return (
    <SystemProvider>
      <IssueSelect
        defaultValues={issue}
        updateForm={updateForm}
      />
    </SystemProvider>
  )
}

export { SidebarIssue }
